(function(config) {
    'use strict';

    angular.module('caffeprint.services', [
            'ngResource'
        ])
        .factory('langHeaderInterceptor', langHeaderInterceptor)
        .factory('lodashService', lodashService)
        .factory('modalSrvc', modalSrvc)
        .factory('printSrvc', printSrvc)
        .factory('momentSrvc', momentSrvc)
        .factory('redirectOutsideSrvc', redirectOutsideSrvc)
        .factory('notificationSrvc', notificationSrvc)
        .factory('downloadLinkSrvc', downloadLinkSrvc)
        .factory('transformResponseSrvc', transformResponseSrvc)
        .factory('transformRequestSrvc', transformRequestSrvc)
        .factory('countryListSrvc', countryListSrvc)
        .factory('uiSortableSrvc', uiSortableSrvc)
        .factory('checkSearchSrvc', checkSearchSrvc)
        .factory('searchFilterSrvc', searchFilterSrvc)
        .factory('filterQuerySrvc', filterQuerySrvc)
        .factory('saveFileSrvc', saveFileSrvc)
        .factory('webglSrvc', webglSrvc)
        .factory('uniqueRequestsInterceptor', uniqueRequestsInterceptor)
        .factory('errorNotificationSrvc', errorNotificationSrvc);

    langHeaderInterceptor.$inject = [];

    function langHeaderInterceptor() {
        return {
            request: function(config) {
                config.headers['Accept-Language'] = 'pl';
                return config;
            }
        };
    }

    lodashService.$inject = [];

    function lodashService() {
        return window._;
    }

    modalSrvc.$inject = ['$uibModal'];

    function modalSrvc($uibModal) {

        return {
            confirmRemove: confirmRemove,
            confirmAction: confirmAction
        };

        function confirmRemove(name, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/caffeprint/views/modal-confirm/modal-confirm.html',
                controller: 'ModalConfirmController',
                controllerAs: 'ctrl',
                resolve: {
                    name: function() {
                        return name;
                    },
                    title: ['modalConfirmConst', function(modalConfirmConst) {
                        return modalConfirmConst.removeTitle;
                    }],
                    descriptionPrefix: ['modalConfirmConst', function(modalConfirmConst) {
                        return modalConfirmConst.removeDescriptionPrefix;
                    }]
                }
            }).result.then(okCallback, cancelCallback);
        }

        function confirmAction(name, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/caffeprint/views/modal-confirm/modal-confirm.html',
                controller: 'ModalConfirmController',
                controllerAs: 'ctrl',
                resolve: {
                    name: function() {
                        return name;
                    },
                    title: ['modalConfirmConst', function(modalConfirmConst) {
                        return modalConfirmConst.actionTitle;
                    }],
                    descriptionPrefix: ['modalConfirmConst', function(modalConfirmConst) {
                        return modalConfirmConst.actionDescriptionPrefix;
                    }]
                }
            }).result.then(okCallback, cancelCallback);
        }
    }

    printSrvc.$inject = ['$window'];

    function printSrvc($window) {

        function print(url) {
            var html  =
                "<html><head>" +
                "</head>" +
                "<body  style ='-webkit-print-color-adjust:exact;'>"+
                "<img src=\"" + url + "\" onload=\"self.focus(); self.print(); self.close()\"/>" +
                "</body>";
            var win = $window.open("about:blank", "_new");
            win.document.write(html);
        }

        function printAlt(url, width, height) {
            var popupWin = $window.open('', '_blank');
            if (width && height) {
                popupWin.document.write('<img width="'+ width +'px" height="'+ height +'px" src="' + url + '"/>');
            } else {
                popupWin.document.write('<img src="' + url + '"/>');
            }

            popupWin.document.close();
            popupWin.setTimeout(function () {
                popupWin.focus();
                popupWin.print();
                popupWin.close();
            }, 200);
        }

        return {
            print: print,
            printAlt: printAlt
        };
    }

    momentSrvc.$inject = ['dateFormatConst'];

    function momentSrvc(dateFormatConst) {
        var moment = window.moment;

        /*
         * Get date formatted to default look of date.
         */
        function dateToStr(date) {
            return moment(date).format(dateFormatConst.momentDate);
        }

        /**
         * Get date from string.
         */
        function strToDate(str) {
            return moment(str, dateFormatConst.momentDate).toDate();
        }

        /*
         * Get datetime formatted to default look of datetime.
         */
        function datetimeToStr(date) {
            return moment(date).format(dateFormatConst.momentDatetime);
        }

        /**
         * Get datetime from string.
         */
        function strToDatetime(str) {
            return moment(str, dateFormatConst.momentDatetime).toDate();
        }

        /*
         * Get time formatted to default look of time.
         */
        function timeToStr(date) {
            return moment(date).seconds(0).format(dateFormatConst.momentTime);
        }

        /**
         * Get time from string.
         */
        function strToTime(str) {
            return moment(str, dateFormatConst.momentTime).toDate();
        }

        /*
         * Get year from date str.
         */
        function dateYear(date) {
            return moment(date, dateFormatConst.momentDate).format(dateFormatConst.momentYear);
        }

        /*
         * Get month from date str.
         */
        function dateMonth(date) {
            return moment(date, dateFormatConst.momentDate).format(dateFormatConst.momentMonth);
        }

        /**
         * Get current year.
         */
        function getCurrentYear() {
            return dateYear(getCurrentDate());
        }

        /**
         * Get current month.
         */
        function getCurrentMonth() {
            return dateMonth(getCurrentDate());
        }

        /**
         * Get current date.
         */
        function getCurrentDate() {
            return moment().toDate();
        }

        /*
         * Returns true if given date is not a weekend day, otherwise returns false.
         */
        function disabledWeekends(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        function getPythonDateValue(str) {
            return moment(str, dateFormatConst.momentDate)
                .format(dateFormatConst.defaultPythonDate);
        }

        function getPythonDatetimeValue(str) {
            return moment(str, dateFormatConst.momentDatetime)
                .format(dateFormatConst.defaultPythonDatetime);
        }

        return {
            moment: moment,
            dateToStr: dateToStr,
            strToDate: strToDate,
            datetimeToStr: datetimeToStr,
            strToDatetime: strToDatetime,
            timeToStr: timeToStr,
            strToTime: strToTime,
            dateYear: dateYear,
            dateMonth: dateMonth,
            disabledWeekends: disabledWeekends,
            getCurrentYear: getCurrentYear,
            getCurrentMonth: getCurrentMonth,
            getCurrentDate: getCurrentDate,
            getPythonDateValue: getPythonDateValue,
            getPythonDatetimeValue: getPythonDatetimeValue,
        };
    }

    redirectOutsideSrvc.$inject = ['$window'];

    function redirectOutsideSrvc($window) {

        /*
         * Open new windiow with given url.
         */
        function go(url) {
            $window.open(url);
        }

        return {
            go: go
        };
    }

    notificationSrvc.$inject = ['toaster'];

    function notificationSrvc(toaster) {

        return {
            notification: notification,
        };

        function notification(type, body, title, showCloseButton, timeout) {
            if (type === 'success') {
                toaster.clear();
                timeout = 5000;
            } else if (type === 'error') {
                showCloseButton = true;
                timeout = 0;
            } else {
                showCloseButton = showCloseButton || true;
                timeout = timeout || 2000;
            }

            toaster.pop({
                type: type,
                body: body,
                bodyOutputType: 'trustedHtml',
                showCloseButton: showCloseButton,
                timeout: timeout,
                title: title
            });
        }
    }

    downloadLinkSrvc.$inject = ['$window'];

    function downloadLinkSrvc($window) {
        return {
            createLink: createLink,
            clickLink: clickLink,
            createLinkFileUrl: createLinkFileUrl,
            clickLinkFileUrl: clickLinkFileUrl,
            saveFile: saveFile
        };

        function createLink(response) {
            var url = $window.URL || $window.webkitURL,
                href = url.createObjectURL(new Blob([response.blob])),
                a = document.createElement('a');
            a.href = href;
            a.download = response.fileName;
            a.target = '_blank';

            return a;
        }

        function clickLink(response) {
            var link = createLink(response);
            link.click();
        }

        function createLinkFileUrl(dataurl, filename) {
            var a = document.createElement('a');
            a.href = dataurl;
            a.download = filename;
            a.target = '_blank';

            return a;
        }

        function clickLinkFileUrl(dataurl, filename) {
            var link = createLinkFileUrl(dataurl, filename);
            link.click();
        }

        function saveFile(response) {
            var blob = new Blob([response.blob]);
            saveAs(blob, response.fileName);
        }
    }

    transformResponseSrvc.$inject = [];

    function transformResponseSrvc() {

        return {
            pdfArrayBufferTransform: pdfArrayBufferTransform,
            excelArrayBufferTransform: excelArrayBufferTransform,
            txtArrayBufferTransform: txtArrayBufferTransform,
            csvArrayBufferTransform: csvArrayBufferTransform,
            xmlArrayBufferTransform: xmlArrayBufferTransform
        };

        function pdfArrayBufferTransform(data, headers) {
            var pdf;
            if (data) {
                pdf = new Blob([data], {
                    type: 'application/pdf'
                });
            }
            var fileName = getFileNameFromHeader(headers('content-disposition'));
            return {
                blob: pdf,
                fileName: fileName
            };
        }

        function excelArrayBufferTransform(data, headers) {
            var excel;
            if (data) {
                excel = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
            }
            var fileName = getFileNameFromHeader(headers('content-disposition'));
            return {
                blob: excel,
                fileName: fileName
            };
        }

        function txtArrayBufferTransform(data, headers) {
            var txt;
            if (data) {
                txt = new Blob([data], {
                    type: 'text/plain'
                });
            }
            var fileName = getFileNameFromHeader(headers('content-disposition'));
            return {
                blob: txt,
                fileName: fileName
            };
        }

        function getFileNameFromHeader(header) {
            if (!header) {
                return null;
            }

            var result = header.split(";")[1].trim().split("=")[1];

            return result.replace(/"/g, '');
        }

        function csvArrayBufferTransform(data, headers) {
            var csv;
            if (data) {
                csv = new Blob([data], {
                    type: 'text/csv'
                });
            }
            var fileName = getFileNameFromHeader(headers('content-disposition'));
            return {
                blob: csv,
                fileName: fileName
            };
        }

        function xmlArrayBufferTransform(data, headers) {
            var xml;
            if (data) {
                xml = new Blob([data], {
                    type: 'application/xml'
                });
            }
            var fileName = getFileNameFromHeader(headers('content-disposition'));
            return {
                blob: xml,
                fileName: fileName
            };
        }
    }

    transformRequestSrvc.$inject = [];

    function transformRequestSrvc() {

        return {
            formDataTransform: formDataTransform,
            nestedFormDataTransform: nestedFormDataTransform,
            multipleFormDataTransform: multipleFormDataTransform
        };

        function toFormData(obj, form, namespace) {
            var fd = form || new FormData();
            var formKey;

            for (var property in obj) {
                if (obj.hasOwnProperty(property) && obj[property]) {
                    if (namespace) {
                        formKey = namespace + '[' + property + ']';
                    } else {
                        formKey = property;
                    }

                    // if the property is an object, but not a File, use recursivity.
                    if (obj[property] instanceof Date) {
                        fd.append(formKey, obj[property].toISOString());
                    }
                    else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                        toFormData(obj[property], fd, formKey);
                    } else { // if it's a string or a File object
                        fd.append(formKey, obj[property]);
                    }
                }
            }

            return fd;
        }

        /**
         * This method will allow us to change how the data is sent up to the server
         * for which we'll need to encapsulate the model data in 'FormData'
         */
        function formDataTransform(data) {
            if (data === undefined) {
                return data;
            }

            var fd = new FormData();
            angular.forEach(data, function(value, key) {
                if (value instanceof Date) {
                    fd.append(key, value.toISOString());
                } else if (value instanceof Array) {
                    fd.append(key, JSON.stringify(value));
                } else if (value !== undefined && value !== null) {
                    fd.append(key, value);
                }
            });

            return fd;
        }

        function multipleFormDataTransform(data) {
            if (data === undefined) {
                return data;
            }

            var fd = new FormData();
            angular.forEach(data, function(value, key) {
                if (value instanceof Date) {
                    fd.append(key, value.toISOString());
                } else if (value instanceof Array) {
                    angular.forEach(value, function(item) {
                        fd.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    fd.append(key, value);
                }
            });

            return fd;
        }

        function nestedFormDataTransform(data, headersGetter) {
            if (data === undefined) {
                return data;
            }

            headersGetter()['Content-Type'] = undefined;

            return toFormData(data);
        }
    }

    countryListSrvc.$inject = ['$resource'];

    function countryListSrvc($resource) {
        return $resource(config.api + '/api/v1/country-list/', {}, {});
    }

    uiSortableSrvc.$inject = [];

    function uiSortableSrvc() {

        function getStopFn(onReorderFn, rows, e, ui, withSearch) {
            var oldPos = ui.item.sortable.index;
            var newPos = ui.item.sortable.dropindex;
            if (newPos !== oldPos && onReorderFn !== undefined) {
                var dragDirection = oldPos - newPos;
                onReorderFn({
                    row: rows[newPos],
                    newPos: newPos,
                    dragDirection: dragDirection
                });
            }
        }

        return {
            getStopFn: getStopFn
        };
    }

    searchFilterSrvc.$inject = ['momentSrvc'];

    function searchFilterSrvc(momentSrvc) {

        function getCheckboxFilterValue(v) {
            if (v === true) {
                return 'True';
            } else if (v === false) {
                return 'False';
            } else {
                return null;
            }
        }

        function getOrderValue(value, cols) {
            if (!value) {
                return;
            }

            var tmp_value;
            if (value.startsWith('-')) {
                tmp_value = value.substring(1);
            } else {
                tmp_value = value;
            }

            var tmpCol = cols.find(function(item) {
                return item.value === tmp_value;
            });

            if (!tmpCol || !tmpCol.orderValue) {
                return value;
            } else if (value.startsWith('-')) {
                return '-' + tmpCol.orderValue;
            } else {
                return tmpCol.orderValue;
            }
        }

        function getDateValue(str) {
            return str ? momentSrvc.getPythonDateValue(str) : null;
        }

        function getDatetimeValue(str) {
            return str ? momentSrvc.getPythonDatetimeValue(str) : null;
        }

        return {
            getCheckboxFilterValue: getCheckboxFilterValue,
            getOrderValue: getOrderValue,
            getDateValue: getDateValue,
            getDatetimeValue: getDatetimeValue,
        };
    }

    checkSearchSrvc.$inject = ['lodashService'];

    function checkSearchSrvc(lodashService) {
        function check(obj) {
            var checkObj = angular.copy(obj);
            delete checkObj.page;
            delete checkObj.page_size;

            if (lodashService.some(checkObj, Boolean)) {
                return checkObj;
            } else {
                return obj;
            }
        }

        function recall(opts, fn) {
            opts.page = 1;
            fn(opts);
        }

        return {
            check: check,
            recall: recall
        };
    }

    filterQuerySrvc.$inject = ['$location', '$state', 'localStorageService', 'lodashService'];

    function filterQuerySrvc($location, $state, localStorageService, lodashService) {

        var filterDataObj = 'caffeprint.admin.filterData',
            pageOptsObj = 'caffeprint.admin.pageOpts',
            searchQueryObj = 'caffeprint.admin.searchQuery',
            extraDataObj = 'caffeprint.admin.extraData';

        return {
            setLocationParams: setLocationParams,
            initializeFilterData: initializeFilterData,
            initializePageOpts: initializePageOpts,
            initializeSearchQuery: initializeSearchQuery,
            initializeExtraData: initializeExtraData,
            updateFilterData: updateFilterData,
            updatePageOpts: updatePageOpts,
            updateSearchQuery: updateSearchQuery,
            updateExtraData: updateExtraData
        };

        function setLocationParams() {
            var filterData = getFilteredData() || {},
                pageOpts = getPageOpts() || {},
                searchQuery = getSearchQuery() || {};

            $location.search(angular.extend(
                {},
                filterData[$state.current.name] || {},
                pageOpts[$state.current.name] || {},
                searchQuery[$state.current.name] || {}
            ));
        }

        function initializeQueryParams(queryData, queryGetFn, querySetFn, queryNameSuffix) {
            var params = $location.search(),
                paramsForQuery = {},
                query = queryGetFn() || {},
                nameSuffix = (typeof queryNameSuffix === 'undefined') ? '' : queryNameSuffix,
                current = query[$state.current.name + nameSuffix],
                data = angular.copy(queryData),
                key,
                value;

            for (key in queryData) {
                if (queryData.hasOwnProperty(key) && params.hasOwnProperty(key)) {
                    if (Array.isArray(params[key])) {
                        paramsForQuery[key] = params[key].map(function (item) {
                            if (lodashService.isString(item)) {
                                return item === 'true' ? true :
                                        item === 'false' ? false :
                                        item;
                            } else {
                                return item;
                            }
                        });
                    } else {
                        paramsForQuery[key] = params[key];
                    }
                }
            }

            if (angular.equals(paramsForQuery, {})) {
                if (current) {
                    data = angular.copy(current);
                }
            } else {
                data = {};
                for (key in paramsForQuery)  {
                    if (paramsForQuery.hasOwnProperty(key)) {
                        value = paramsForQuery[key];
                        if (lodashService.isString(value) && isNumber(value)) value = Number(value);
                        if (lodashService.isString(value)) {
                            value = value === 'true' ? true :
                                    value === 'false' ? false :
                                    value;
                        }
                        if (Array.isArray(queryData[key]) && !Array.isArray(value)) {
                            data[key] = [value];
                        } else {
                            data[key] = value;
                        }
                    }
                }
            }

            query[$state.current.name + nameSuffix] = data;

            querySetFn(query);

            for (key in queryData) {
                if (queryData.hasOwnProperty(key)) {
                    if (!data.hasOwnProperty(key)) {
                        if (Array.isArray(queryData[key])) {
                            data[key] = [];
                        } else {
                            data[key] = null;
                        }
                    }
                }
            }

            return data;
        }

        function updateQueryParams(queryData, queryGetFn, querySetFn, queryIsFn, queryNameSuffix) {
            var query,
                nameSuffix = (typeof queryNameSuffix === 'undefined') ? '' : queryNameSuffix;

            if (queryIsFn()) {
                query = queryGetFn();

            } else {
                query = {};
            }
            query[$state.current.name + nameSuffix] = queryData;
            querySetFn(query);
        }

        function initializeFilterData(filterData, queryNameSuffix) {
            return initializeQueryParams(filterData, getFilteredData, setFilterData, queryNameSuffix);
        }

        function initializePageOpts(pageOpts, queryNameSuffix) {
            var pageOptsCopy = angular.copy(pageOpts);
            if (pageOptsCopy.hasOwnProperty('count')) delete pageOptsCopy.count;
            return initializeQueryParams(pageOptsCopy, getPageOpts, setPageOpts, queryNameSuffix);
        }

        function initializeSearchQuery(searchQuery, queryNameSuffix) {
            return initializeQueryParams(searchQuery, getSearchQuery, setSearchQuery, queryNameSuffix);
        }

        function initializeExtraData(extraData, queryNameSuffix) {
            return initializeQueryParams(extraData, getExtraData, setExtraData, queryNameSuffix);
        }

        function updateFilterData(filterData, queryNameSuffix) {
            updateQueryParams(filterData, getFilteredData, setFilterData, isFilterData, queryNameSuffix);
        }
        
        function updatePageOpts(pageOpts, queryNameSuffix) {
            var pageOptsCopy = angular.copy(pageOpts);
            if (pageOptsCopy.hasOwnProperty('count')) delete pageOptsCopy.count;
            updateQueryParams(pageOptsCopy, getPageOpts, setPageOpts, isPageOpts, queryNameSuffix);
        }
        
        function updateSearchQuery(searchQuery, queryNameSuffix) {
            updateQueryParams(searchQuery, getSearchQuery, setSearchQuery, isSearchQuery, queryNameSuffix);
        }

        function updateExtraData(extraData, queryNameSuffix) {
            updateQueryParams(extraData, getExtraData, setExtraData, isExtraData, queryNameSuffix);
        }

        function getFilteredData() {
            return localStorageService.get(filterDataObj);
        }

        function setFilterData(filterData) {
            localStorageService.set(filterDataObj, filterData);
        }

        function isFilterData() {
            return !!localStorageService.get(filterDataObj);
        }

        function getPageOpts() {
            return localStorageService.get(pageOptsObj);
        }

        function setPageOpts(pageOpts) {
            localStorageService.set(pageOptsObj, pageOpts);
        }

        function isPageOpts() {
            return !!localStorageService.get(pageOptsObj);
        }

        function getSearchQuery() {
            return localStorageService.get(searchQueryObj);
        }

        function setSearchQuery(searchQuery) {
            localStorageService.set(searchQueryObj, searchQuery);
        }

        function isSearchQuery() {
            return !!localStorageService.get(searchQueryObj);
        }

        function getExtraData() {
            return localStorageService.get(extraDataObj);
        }

        function setExtraData(extraData) {
            localStorageService.set(extraDataObj, extraData);
        }

        function isExtraData() {
            return !!localStorageService.get(extraDataObj);
        }

        function isNumber(value) {
            return /^\d+$/.test(value)
        }
    }

    saveFileSrvc.$inject = ['$http', 'notificationSrvc', 'defaultErrorMessages'];

    function saveFileSrvc($http, notificationSrvc, defaultErrorMessages) {

        return {
            saveFile: saveFile
        };

        function saveFile(fileUrl, fileName) {
            return $http.get(fileUrl, {
                responseType: 'arraybuffer'
            }).then(
                function (response) {

                    var blob = new Blob(
                        [response.data],
                        {type: response.headers('Content-Type')}
                    );

                    saveAs(blob, fileName);

                },
                function (response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", defaultErrorMessages.noFileError);
                    } else {
                        notificationSrvc.notification("error", defaultErrorMessages.fileDownloadError);
                    }
                }
            )
        }
    }

    webglSrvc.$inject = [];

    function webglSrvc() {
        return {
            check: check
        };

        function check(return_context) {
            if (!!window.WebGLRenderingContext) {
                var canvas = document.createElement("canvas"),
                     names = ["webgl2", "webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
                   context = false;

                for(var i=0;i< names.length;i++) {
                    try {
                        context = canvas.getContext(names[i]);
                        if (context && typeof context.getParameter == "function") {
                            // WebGL is enabled
                            if (return_context) {
                                // return WebGL object if the function's argument is present
                                return {name:names[i], gl:context};
                            }
                            // else, return just true
                            return true;
                        }
                    } catch(e) {}
                }

                // WebGL is supported, but disabled
                return false;
            }

            // WebGL not supported
            return false;
        }
    }

    uniqueRequestsInterceptor.$inject = ['$injector', '$q'];

    function uniqueRequestsInterceptor($injector, $q) {
        var uniqueRequestOptionName = "unique";
        var requestIdOptionName = 'requestId';
        var defaultRequestIdOptionName = 'url';

        /**
         * Care about duplicates check.
         */
        function canBeDuplicated(requestConfig) {
            return !requestConfig[uniqueRequestOptionName];
        }

        /**
         * Find identical request in pending requests
         */
        function isPending(pendingRequests, requestConfig) {
            var duplicated = pendingRequests.filter(function(pendingReqConfig) {
                if (pendingReqConfig.hasOwnProperty(requestIdOptionName)) {
                    return pendingReqConfig[requestIdOptionName] &&
                        pendingReqConfig[requestIdOptionName] === requestConfig[requestIdOptionName];
                } else {
                    return pendingReqConfig[defaultRequestIdOptionName] &&
                        pendingReqConfig[defaultRequestIdOptionName] === requestConfig[defaultRequestIdOptionName];
                }
            });
            return duplicated.length > 0;
        }

        function isDuplicated(pendingRequests, requestConfig) {
            if (!canBeDuplicated(requestConfig) && isPending(pendingRequests, requestConfig)) {
                return true;
            } else {
                return false;
            }
        }

        return {
            request: function(config) {
                var $http = $injector.get('$http');

                if (isDuplicated($http.pendingRequests, config)) {
                    var canceler = $q.defer();
                    config.timeout = canceler.promise;
                    canceler.resolve();
                }

                return config;
            }
        };
    }

    errorNotificationSrvc.$inject = ['notificationSrvc', 'defaultErrorMessages'];

    function errorNotificationSrvc(notificationSrvc, defaultErrorMessages) {
        return {
            displayErrors: displayErrors
        };

        function displayErrors(data) {
            var msg = [],
                result = flatten(data);
            for (var key in result) {
                if (result.hasOwnProperty(key)) {
                    msg.push(key + ": " + result[key])
                }
            }

            notificationSrvc.notification("error", msg.join('<br>'), defaultErrorMessages.defaultError);
        }

        function flatten (target, opts) {
            opts = opts || {};

            var delimiter = opts.delimiter || '.';
            var maxDepth = opts.maxDepth;
            var output = {};

            function step(object, prev, currentDepth) {
                currentDepth = currentDepth || 1;
                Object.keys(object).forEach(function (key) {
                    var value = object[key];
                    var isarray = opts.safe && Array.isArray(value);
                    var type = Object.prototype.toString.call(value);
                    var isobject = (
                        type === '[object Object]' ||
                        type === '[object Array]'
                    );

                    var newKey = prev
                        ? prev + delimiter + key
                        : key;

                    if (!isarray && isobject && Object.keys(value).length &&
                        (!opts.maxDepth || currentDepth < maxDepth)) {
                        return step(value, newKey, currentDepth + 1)
                    }

                    output[newKey] = value
                })
            }

            step(target);

            return output
        }
    }
})(window.config);
